(function (window) {
  var strings = BatchGeoStrings.getStringsForComponent(
    "BatchGeoStoreLocatorNoResultsView",
  );

  /**
   * BatchGeoStoreLocatorNoResultsView creates and manages the view that is
   * displayed when no results are returned when searched or when too many
   * filters are applied so nothing is found. This provides the user with an
   * error message and a way to get out of no results and return all the
   * results again.
   *
   * @constructor
   */
  var BatchGeoStoreLocatorNoResultsView = function () {};

  /**
   * Returns the the latest search result. You can have infinite amount of
   * searches since searches stack up. For example, search for foo then bar
   * means it finds all results from foo first then searches within those
   * results for bar. We want to show the last search term they provided to
   * give them an error message that makes sense.
   */
  BatchGeoStoreLocatorNoResultsView.prototype.getLatestSearchResult =
    function () {
      return _.findLast(
        BatchGeoStore.getState().MarkerLegend.filters,
        function (item) {
          return item.column === "Search";
        },
      );
    };

  /**
   * A private method to handle clicking on the reset search button. Longer
   * term it'd be nice to use dispatch or something instead of manually
   * calling a method on an instance like this.
   *
   * @private
   */
  BatchGeoStoreLocatorNoResultsView.prototype._resetButtonHandler =
    function () {
      window.batchGeoGoogleMapsMarker.MarkerLegend.clearFilters();
    };

  /**
   * Renders the view for a no results screen. It will get the latest search
   * result and then display a no results found message with the search term
   * the user used last.
   */
  BatchGeoStoreLocatorNoResultsView.prototype.render = function () {
    var searchResult = this.getLatestSearchResult();
    return $("<div />", {
      addClass: "storeLocator-no-results-wrapper",
      html: [
        $("<h5 />", {
          addClass: "storeLocator-no-results-title",
          text: strings.get("TITLE", {
            resultValue: searchResult
              ? 'for "' + searchResult.group + '"'
              : "found",
          }),
        }),
        $("<p />", {
          addClass: "storeLocator-no-results-message",
          html: strings.get("MESSAGE"),
        }),
        $("<button />", {
          addClass: "storeLocator-no-results-reset-button",
          text: strings.get("RESET_BUTTON"),
          click: this._resetButtonHandler,
        }),
      ],
    });
  };

  window.BatchGeoStoreLocatorNoResultsView = BatchGeoStoreLocatorNoResultsView;
})(window);
